import { serviceLocatorInstance } from '@/services/ServiceLocator'
import { ITranslationService } from '@/services/translation/ITranslationService'
import { TranslateResult } from 'vue-i18n'

export default function translateOrFallback(key: string, fallback: string): string | TranslateResult {
  const translateService = serviceLocatorInstance.get<ITranslationService>('translation').getI18nPlugin()
  const result = translateService.t(key)
  return result === key ? fallback : result
}
